/* eslint-disable @typescript-eslint/no-unused-vars */
import { ButtonBase, Menu, MenuItem } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { breakContract, getStudentAffiliate } from '@webapps/business';
import {
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const TableActions = ({ contactMember, deleteMember, id, viewMember, email, addAbsence, refetchAbsenceHours, handleDownloadStatement }) => {
  const { classes, css, global, cx, theme: { spacing }, } = useStyles(styles);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { addToast } = useToast();

  const [viewConfirmBreakContract, setViewConfirmBreakContract] =
    useState(false);

  const handleOpenViewConfirmBreakContract = () => {
    setViewConfirmBreakContract(true);
  };

  const handleCloseViewConfirmBreakContract = () => {
    setViewConfirmBreakContract(false);
  };

  const { data: { data: info = [] } = {}, refetch: refetchInfoContract } =
    useQuery(getStudentAffiliate, {
      key: ['infoStudentSchoolAffiliatee', id],
      variables: { id, type: 'school', status: 'enclosed' },
    });

  const {
    error: errorBreakContract,
    isLoading: isLoadingBreakContract,
    isSuccess: isSuccessBreakContract,
    mutateAsync: mutateBreakContract,
  } = useMutation(breakContract);

  const breakStudentContract = () => {
    mutateBreakContract({
      id: info[0]?.contract?.id,
      actor: 'school',
      forEntity: 'student',
    });
  };

  useEffect(() => {
    if (errorBreakContract) {
      addToast({
        status: 'error',
        message: 'Erreur',
      });
    }
    if (isSuccessBreakContract) {
      addToast({
        status: 'success',
        message: 'Le contrat a été arrêté avec succès',
      });
      refetchInfoContract();
      handleCloseViewConfirmBreakContract();
    }
  }, [isSuccessBreakContract, errorBreakContract]);

  return (
    <div>
      <ButtonBase onClick={handleClick} style={{ margin: '0px 3px', alignSelf: 'baseline', borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '26px', display: 'flex', justifyContent: 'center', height: '26px', alignItems: 'center', cursor: 'pointer' }} >
        <MoreHoriz fontSize="small" onClick={handleClick} style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
      </ButtonBase>

      <Menu
        anchorEl={anchorEl}
        id="candidature-menu"
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{ elevation: 2 }}
        transformOrigin={{ horizontal: 'left', vertical: -50 }}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
      >
        <MenuItem onClick={() => viewMember(id)}>Voir les détails</MenuItem>
        <MenuItem onClick={() => contactMember(id)}>
          Contacter le membre
        </MenuItem>

        {!info[0]?.contract && (
          <MenuItem onClick={() => deleteMember(id)}>
            Supprimer de la classe
          </MenuItem>
        )}
        {info[0]?.contract?.status === 'ARCHIVED' && (
          <MenuItem onClick={handleOpenViewConfirmBreakContract}>
            Arrêter le contrat
          </MenuItem>
        )}
        {info[0]?.classroom?.planning && (
          <>
            <MenuItem onClick={() => addAbsence()}>
              Déclarer une absence
            </MenuItem>
            <MenuItem onClick={() => {handleDownloadStatement()}}
              >
              Télécharger le relevé
            </MenuItem>
          </>
        )}
      </Menu>

      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={breakStudentContract}
        isLoading={isLoadingBreakContract}
        onClose={handleCloseViewConfirmBreakContract}
        open={viewConfirmBreakContract}
        title="Arrêter le contrat"
      >
        Êtes-vous sûr de vouloir arrêter le contrat
      </ModalConfirm>
    </div>
  );
};

const styles = ({ spacing }) => ({
  buttonAction: {
    alignItems: 'center',
    borderRadius: '10.0px',
    padding: spacing(0.5),
  },
});

TableActions.propTypes = {
  id: PropTypes.number.isRequired,
  viewMember: PropTypes.func,
  contactMember: PropTypes.func,
  deleteMember: PropTypes.func,
};

export default TableActions;
